/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthSupportPagedList } from '../../models/auth-support-paged-list';
import { AuthSupportSortFieldName } from '../../models/auth-support-sort-field-name';
import { SortDirection } from '../../models/sort-direction';

export interface SearchAuthSupportsList$Any$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates if only available auth supports (true), only assigned (false) or all (null) should be returned
 */
  availableAuthSupport?: boolean;

/**
 * Indicates if only auth supports with associated transactions (true), only auth supports with no associated transactions (false) or all auth supports (null) should be returned (ignored when using hibernate search)
 */
  hasTransactionsAuthSupport?: boolean;

/**
 * Indicates if only auth supports with associated transactions (true), only auth supports with no associated transactions (false) or all auth supports (null) should be returned (ignored when using hibernate search)
 */
  hasSynchroFailed?: boolean;

/**
 * The search text to filter API
 */
  search?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * TYPE : the auth support type
 *   * VALUE : the auth support value
 *   * STATE : the auth support state
 *   * CREATION_DATE : the auth support creation date
 *   * VALIDITY_START
 *   * VALIDITY_END
 *   * SUBSERVICE_NAME
 *   * SUBSCRIPTION_NAME
 */
  sortFieldName?: AuthSupportSortFieldName & any;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search auth support
     */
    body?: any
}

export function searchAuthSupportsList$Any(http: HttpClient, rootUrl: string, params?: SearchAuthSupportsList$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchAuthSupportsList$Any.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('availableAuthSupport', params.availableAuthSupport, {});
    rb.query('hasTransactionsAuthSupport', params.hasTransactionsAuthSupport, {});
    rb.query('hasSynchroFailed', params.hasSynchroFailed, {});
    rb.query('search', params.search, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/octet-stream');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthSupportPagedList>;
    })
  );
}

searchAuthSupportsList$Any.PATH = '/auth-supports/search';
